const errorEnum: { [key: string]: any } = {
  1: "permission denied",
  2: "position unavalablf",
  3: "timeout",
  4: "unknow error",
}
/**
 * @dtsModule max.location
 * @dtsNamespace location
 * @dtsDesc location Location
 */
export const locationDSL = {
  /**
   * @dtsExport
   * Get the current latitude and longitude
   * [SUNMI Doc](https://doc.maxiot.com/developer?page=max.location.get&lang=%{locale}%)
   */
  async get(): Promise<TLocation> {
    return new Promise((reslove, reject) => {
      navigator?.geolocation?.getCurrentPosition(
        (p) => {
          reslove({
            latitude: p.coords.latitude,
            longitude: p.coords.longitude,
          })
        },
        (e) => {
          reject(errorEnum[e.code])
        }
      )
    })
  },
}
